import { Typography } from "@mui/material";
import { DoNotDisturbOutlined } from "@mui/icons-material";
import { AppModal, bodyTextSx } from "global/components/AppModal";
import strings from "global/constants/StringConstants";

interface CustomProps {
  open: boolean;
  /** Display name of the gated feature, e.g. "Bulk send". Falls back to generic copy. */
  featureName?: string;
  message?: string;
  onClose: () => void;
}

const MaintenanceBanner = (props: CustomProps) => {
  return (
    <AppModal
      open={props.open}
      onClose={props.onClose}
      title={
        props.featureName ? `${props.featureName} is switched off` : "Feature switched off"
      }
      // Deliberately off, not broken — the app only models "disabled by an
      // admin", never an outage, so this reads as neutral/purple rather than
      // the red "something's down" tone.
      tone="neutral"
      icon={<DoNotDisturbOutlined sx={{ fontSize: 19 }} />}
      size="sm"
      primaryLabel="Got it"
      onPrimary={props.onClose}
      hideCancel
    >
      <Typography sx={bodyTextSx}>
        {props.message ?? strings.FEATURE_GATE_FALLBACK_MAINTENANCE_MESSAGE}
      </Typography>
    </AppModal>
  );
};

export default MaintenanceBanner;
